import { render, staticRenderFns } from "./TopMenu.vue?vue&type=template&id=6f31b64e"
import script from "./TopMenu.vue?vue&type=script&lang=js"
export * from "./TopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports